import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import ServiceHeader from "assets/services/trip-basis-banner.webp";
import PickUp from "components/templates/PickUp";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";

import appstoreEn from "assets/app-store--en.svg";
import appstoreAr from "assets/app-store--ar.svg";
import playStoreEn from "assets/google-play--en.svg";
import playstoreAr from "assets/google-play--ar.svg";

import appStoreDarkEn from "assets/app-store-dark--en.svg";
import appStoreDarkAr from "assets/app-store-dark--ar.svg";
import playStoreDarkEn from "assets/google-play-dark--en.svg";
import playStoreDarkAr from "assets/google-play-dark--ar.svg";

import complimentaryServicesA from "assets/services/city1.svg";
import complimentaryServicesB from "assets/services/city2.svg";
import complimentaryServicesC from "assets/services/city3.svg";

import City from "assets/services/cityA.webp";

import CityA from "assets/cities/riyadh.webp";
import CityB from "assets/cities/bahrain2.webp";
import CityC from "assets/cities/qassim.webp";
import CityD from "assets/cities/Damman2.webp";
import CityE from "assets/cities/al-jubail.webp";
import CityF from "assets/cities/jeddah.webp";
import CityG from "assets/cities/madina.webp";
import CityH from "assets/cities/makkah.webp";
import CityJ from "assets/cities/alula.webp";

import "../../servicepage.scss";
import SwiperSlider from "components/atoms/SwiperSlider";
import { SwiperSlide } from "swiper/react";

import { ReactComponent as ArrowRight } from "assets/arrowRight.svg";
import { ReactComponent as ArrowLeft } from "assets/arrowLeft.svg";
import { Helmet } from "react-helmet";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import DeliveryForm from "components/templates/PickUp/DeliveryForm";
import { bookingActions } from "redux/slices/booking";

const CityToCityTransfer = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation("translation");
  const dispatch = useAppDispatch();
  const mainTab = useAppSelector((state) => state.booking.mainTab);
  const [differentReturnLocation, setDifferentReturnLocation] = useState(false);
  const [deliveryDrawerState, setDeliveryDrawerState] = useState({
    pickup: false,
    destination: false,
  });
  const location = useLocation();
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (i18n.language === "ar" || pathname.includes("/ar")) {
      navigate("/السفر-من-مدينة-الى-مدينة");
    }
  }, [i18n.language, navigate, pathname]);

  const complimentaryServices = [
    {
      title: t("Effortless City-to-City Journeys"),
      content: t("Effortless City-to-City Journeys Description"),
      image: complimentaryServicesA,
    },
    {
      title: t("Enjoy Door-to-Door Convenience"),
      content: t("Enjoy Door-to-Door Convenience Description"),
      image: complimentaryServicesB,
    },
    {
      title: t("Transparent Pricing for Stress-Free Travel"),
      content: t("Transparent Pricing for Stress-Free Travel Description"),
      image: complimentaryServicesC,
    },
  ];

  const swiperRoutes = [
    {
      id: 1,
      from: "riyadh",
      to: "dammam",
      price: 1075.0,
      capacity: 3,
      image: CityA,
    },
    {
      id: 2,
      from: "riyadh",
      to: "bahrain",
      price: 1350.0,
      capacity: 3,
      image: CityB,
    },
    {
      id: 3,
      from: "riyadh",
      to: "qassim",
      price: 1050.0,
      capacity: 4,
      image: CityC,
    },
    {
      id: 4,
      from: "dammam",
      to: "bahrain",
      price: 330.0,
      capacity: 3,
      image: CityD,
    },
    {
      id: 5,
      from: "alJubail",
      to: "bahrain",
      price: 550.0,
      capacity: 3,
      image: CityE,
    },
    {
      id: 6,
      from: "jeddah",
      to: "makkah",
      price: 450.0,
      capacity: 5,
      image: CityF,
    },
    {
      id: 7,
      from: "jeddah",
      to: "madinah",
      price: 1800.0,
      capacity: 5,
      image: CityG,
    },
    {
      id: 8,
      from: "makkah",
      to: "madinah",
      price: 1900.0,
      capacity: 5,
      image: CityH,
    },
    {
      id: 9,
      from: "jeddah",
      to: "alaula",
      price: 1800.0,
      capacity: 3,
      image: CityJ,
    },
  ];
  const faqs = [
    {
      question: t(
        "Is it available to make stops during city-to-city transfer?",
      ),
      answer: t(
        "Is it available to make stops during city-to-city transfer Answer",
      ),
    },
    {
      question: t("How can I contact the chauffeur?"),
      answer: t("How can I contact the chauffeur Answer"),
    },
    {
      question: t("Is it possible to cancel the ride?"),
      answer: t("Is it possible to cancel the ride Answer"),
    },
  ];

  const [expanded, setExpanded] = useState<string | false>(false);

  const handleAccordionChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  const isSmallScreen = window.innerWidth < 768;

  return (
    <>
      <Helmet>
        <title>City to city transfer | Yeloplus</title>
        <meta name="robots" content="index, follow" />
        <meta name="title" content="City to city transfer | Yeloplus" />
        <meta
          name="description"
          content="Travel effortlessly between cities with Yeloplus door-to-door
          service, no hidden fees, skilled chauffeurs, and luxury cars for a
          smooth, flexible ride."
        />
        <link
          rel="canonical"
          href="https://limousine.iyelo.com/en/city-to-city-transfer"
        />
      </Helmet>
      <div className="services__container">
        <Container maxWidth="lg">
          <Box
            className="services__main"
            sx={{
              background: {
                xs: "none",
                md: `linear-gradient(180deg, rgba(0, 0, 0, 0.5) 38.36%, rgba(0, 0, 0, 0.00) 50%),center center / cover url(${ServiceHeader}) no-repeat`,
              },
              backgroundSize: "cover",
              backgroundPosition: "center",
              // ← yeh add karo:
              height: { xs: "auto !important", md: "auto" },
              minHeight: { xs: 0, md: "auto" },
              pb: { xs: 0, md: 0 },
            }}
          >
            <div
              style={{
                display: "flex",
                minHeight: "60vh",
                height: "100%",
                position: "relative",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <div>
                <div className="travel__style_heading">
                  <h1 className="heading">
                    <span style={{ color: "#FFD207" }}>{t("luxury")}</span>{" "}
                    {t("City to City Transfer")}
                  </h1>
                  <p className="sub-heading">
                    {t("City to City Transfer Description")}
                  </p>
                </div>

                {/* THREE MAIN BUTTONS HERE */}
                <Stack
                  direction="row"
                  display={"flex"}
                  spacing={1}
                  sx={{
                    pt: 2,
                    mb: 2,
                    borderRadius: "8px",
                    overflow: "hidden",
                    width: { xs: "100%", md: "fit-content" },
                    // boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                    ml:{ xs: 0, md: 2 },
                    mt: { xs: 0, md: 2 },
                  }}
                >
                  {/* Limousine Button */}
                  <Button
                    onClick={() => dispatch(bookingActions.setMainTab(0))}
                    sx={{
                      position: "relative",
                      height: "40px",
                      px: 2,
                      fontSize: "13px",
                      fontWeight: 500,
                      borderRadius: "8px",
                      textTransform: "none",
                      color: mainTab === 0 ? "#520A76" : "#ffffff",
                      background: mainTab === 0 ? "#ffffff" : "#0000004D",
                      "&:hover": {
                        background: mainTab === 0 ? "#ffff" : "#0000004D",
                      },
                      border: "1px solid #FFFFFF",
                    }}
                  >
                    {t("limousine")}
                  </Button>

                  {/* Delivery Button */}
                  <Button
                    onClick={() => dispatch(bookingActions.setMainTab(1))}
                    sx={{
                      position: "relative",
                      height: "40px",
                      px: 2,
                      fontSize: "13px",
                      fontWeight: 500,
                      borderRadius: "8px",
                      textTransform: "none",
                      color: mainTab === 1 ? "#520A76" : "#ffffff",
                      background: mainTab === 1 ? "#ffffff" : "#0000004D",
                      "&:hover": {
                        background: mainTab === 1 ? "#ffff" : "#0000004D",
                      },
                      border: "1px solid #FFFFFF",
                    }}
                  >
                    {t("rent_with_delivery")}
                    <Box
                      component="span"
                      sx={{
                        position: "absolute",
                        top: -10,
                        right: 4,
                        background: "#FFCD00",
                        px: 0.5,
                        borderTopLeftRadius: "6px",
                        borderBottomRightRadius: "6px",
                        borderTopRightRadius: "6px",
                        "@keyframes bounce": {
                          "0%": { transform: "translateY(0)" },
                          "50%": { transform: "translateY(-5px)" },
                          "100%": { transform: "translateY(0)" },
                        },
                        animation: "bounce 1s infinite", // Add bounce animation when selected
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#520A76",
                          fontSize: "10px",
                          fontWeight: 600,
                          position: "relative",
                          top: "1px",
                        }}
                      >
                        {t("new")}
                      </Typography>
                    </Box>
                  </Button>

                  {/* Events Button */}
                  {/* <Button
                    onClick={() => dispatch(bookingActions.setMainTab(2))}
                    sx={{
                      position: "relative",
                      height: "40px",
                      px: 2,
                      fontSize: "13px",
                      fontWeight: 500,
                      borderRadius: "8px",
                      textTransform: "none",
                      color: mainTab === 2 ? "#520A76" : "#ffffff",
                      background: mainTab === 2 ? "#ffffff" : "#0000004D",
                      "&:hover": {
                        background: mainTab === 2 ? "#ffff" : "#0000004D",
                      },
                      border: "1px solid #FFFFFF",
                      "@keyframes bounce": {
                        "0%": { transform: "translateY(0)" },
                        "50%": { transform: "translateY(-5px)" },
                        "100%": { transform: "translateY(0)" },
                      },
                      animation: "bounce 1s infinite", // Add bounce animation when selected
                    }}
                  >
                    {t("events")}
                    <Box
                      component="span"
                      sx={{
                        position: "absolute",
                        top: -10,
                        right: 4,
                        background: "#FFCD00",

                        px: 0.5,
                        // py: 0.25,
                        borderTopLeftRadius: "6px",
                        borderBottomRightRadius: "6px",
                        borderTopRightRadius: "6px",
                      }}
                    >
                      <Typography
                        sx={{
                          color: "#520A76",
                          fontSize: "10px",
                          fontWeight: 600,
                          position: "relative",
                          top: "1px",
                        }}
                      >
                        {t("new")}
                      </Typography>
                    </Box>
                  </Button> */}
                </Stack>

                <div
                  className={`travel__style ${
                    i18n.language === "en" ? "en-lang" : "ar-lang"
                  }`}
                >
                  <div className="booking__box">
                    <div
                      className={
                        i18n.language === "en" ? "bottom" : "bottom arBottom"
                      }
                    >
                      {/* CONDITIONAL RENDERING BASED ON mainTab */}
                      {mainTab === 0 && <PickUp />}

                      {mainTab === 1 && (
                        <DeliveryForm
                          differentReturnLocation={differentReturnLocation}
                          onDifferentReturnLocationChange={
                            setDifferentReturnLocation
                          }
                          onDrawerStateChange={setDeliveryDrawerState}
                        />
                      )}

                      {mainTab === 2 && (
                        <Box sx={{ p: 4, textAlign: "center", color: "#666" }}>
                          <Typography variant="h6">
                            {t("events_coming_soon") ||
                              "Events booking coming soon!"}
                          </Typography>
                        </Box>
                      )}
                    </div>
                    <div ref={ref}></div>
                  </div>
                </div>
              </div>

              <Stack
                direction={"row"}
                gap={2}
                justifyContent={{
                  xs: "center",
                  md: i18n.language === "ar" ? "flex-end" : "start",
                }}
                mt={4}
              >
                <Box borderRadius={"7px"}>
                  <Link
                    to="https://apps.apple.com/us/app/yelo-limousine/6446365805"
                    target="_blank"
                  >
                    {i18n.language === "en" ? (
                      <>
                        <Box
                          component={"img"}
                          display={{ xs: "none", md: "block" }}
                          src={appstoreEn}
                          alt="App Store"
                        />
                        <Box
                          component={"img"}
                          display={{ xs: "block", md: "none" }}
                          src={appStoreDarkEn}
                          alt="App Store"
                        />
                      </>
                    ) : (
                      <>
                        <Box
                          component={"img"}
                          display={{ xs: "none", md: "block" }}
                          src={appstoreAr}
                          alt="App Store"
                        />
                        <Box
                          component={"img"}
                          display={{ xs: "block", md: "none" }}
                          src={appStoreDarkAr}
                          alt="App Store"
                        />
                      </>
                    )}
                  </Link>
                </Box>
                <Box borderRadius={"7px"}>
                  <Link
                    to="https://play.google.com/store/apps/details?id=com.wefaq.limousine"
                    target="_blank"
                  >
                    {i18n.language === "en" ? (
                      <>
                        <Box
                          component={"img"}
                          display={{ xs: "none", md: "block" }}
                          src={playStoreEn}
                          alt="Play Store"
                        />
                        <Box
                          component={"img"}
                          display={{ xs: "block", md: "none" }}
                          src={playStoreDarkEn}
                          alt="Play Store"
                        />
                      </>
                    ) : (
                      <>
                        <Box
                          component={"img"}
                          display={{ xs: "none", md: "block" }}
                          src={playstoreAr}
                          alt="Play Store"
                        />
                        <Box
                          component={"img"}
                          display={{ xs: "block", md: "none" }}
                          src={playStoreDarkAr}
                          alt="Play Store"
                        />
                      </>
                    )}
                  </Link>
                </Box>
              </Stack>
            </div>
          </Box>

          <Box mt={{ xs: "60px", md: "80px" }}>
            <Grid container spacing={{ xs: 2, md: 0 }}>
              {complimentaryServices.map((complimentaryService, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <Card
                    sx={{
                      height: { md: "100%" },
                      px: { xs: 3, md: 4 },
                      py: { xs: 3, md: 0 },
                      boxShadow: "none",
                      borderRadius: { xs: "16px", md: 0 },
                      borderLeft: { md: "1px solid #ECEBF2" },
                      borderRight: {
                        md: index === 2 ? "1px solid #ECEBF2" : 0,
                      },
                    }}
                  >
                    <CardContent
                      sx={{
                        display: "flex",
                        p: "0 !important",
                        flexDirection: "column",
                        gap: 2,
                      }}
                    >
                      <img
                        src={complimentaryService.image}
                        alt={`${t(complimentaryService.title)}`}
                        style={{ maxWidth: "68px" }}
                      />
                      <Box display={"flex"} flexDirection={"column"} gap={1}>
                        <Typography
                          variant="h6"
                          component="h3"
                          fontSize={16}
                          fontWeight={700}
                          color={"#520A76"}
                          letterSpacing={"0.14px"}
                          textOverflow={"ellipsis"}
                        >
                          {complimentaryService.title}
                        </Typography>
                        <Typography variant="body2" fontSize={16}>
                          {complimentaryService.content}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>

          <Box mt={{ xs: "60px", md: "80px" }}>
            <Grid
              container
              columnSpacing={4}
              rowSpacing={{ xs: "60px", md: "80px" }}
              alignItems={"center"}
            >
              <Grid item xs={12} md={6}>
                <Box>
                  <Typography
                    component="h3"
                    sx={{
                      color: "#520A76",
                      mb: { xs: 2, md: 3 },
                      fontWeight: { xs: 600, md: 700 },
                      fontSize: { xs: "18px", md: "24px" },
                    }}
                  >
                    {t("Connecting cities with premium city to city service")}
                  </Typography>
                  <Typography
                    fontSize={16}
                    sx={{
                      mb: { xs: 2, md: 3 },
                    }}
                  >
                    {t(
                      "Connecting cities with premium city to city service description",
                    )}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    height: "400px",
                    borderRadius: "16px",
                    overflow: "hidden",
                    backgroundImage: `url(${City})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </Container>

        <Box mt={{ xs: "60px", md: "80px" }}>
          <SwiperSlider
            name="city"
            slidesPerViews={5}
            showNavigation={true}
            heading={t("City to City Transfer")}
          >
            {swiperRoutes.map((route, index) => (
              <SwiperSlide key={index} style={{ width: "auto" }}>
                <Box
                  sx={{
                    display: "flex",
                    position: "relative",
                    borderRadius: "16px",
                    overflow: "hidden",
                    cursor: "pointer",
                    "&:hover img": {
                      transform: "scale(1.15)",
                    },
                  }}
                >
                  <Box
                    component="img"
                    src={route.image}
                    alt={`${t(route.from)} to ${t(route.to)}`}
                    sx={{
                      overflow: "hidden",
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      transition: "transform .5s ease 0s",
                      minHeight: { xs: "auto", md: "285px" },
                    }}
                  />
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      right: 0,
                      p: { xs: "8px", sm: 2 },
                      color: "white",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontSize: { xs: "14px", sm: "16px" },
                        fontWeight: 600,
                        lineHeight: { xs: "18px", md: "22px" },
                        letterSpacing: "0.18px",
                      }}
                    >
                      {t(route.from)} - {t(route.to)}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "13px",
                        fontWeight: 400,
                        lineHeight: "24px",
                        letterSpacing: "0.16px",
                        display: "flex",
                        alignItems: "center",
                        color: "#fccc00",
                      }}
                    >
                      {t("priceFrom")} {route.price.toFixed(2)} {t("SAR")}
                    </Typography>
                  </Box>
                </Box>
              </SwiperSlide>
            ))}
          </SwiperSlider>
        </Box>

        <Container maxWidth="lg">
          <Box mt={{ xs: "60px", md: "80px" }}>
            <Typography
              variant="h4"
              sx={{
                color: "#520a76",
                fontSize: { xs: 24, md: 32 },
                fontWeight: "bold",
                lineHeight: { xs: "32px", md: "48px" },
                letterSpacing: "0.165px",
                mb: { xs: 2, md: 4 },
              }}
            >
              {t("Frequently Asked Question")}
            </Typography>

            <Grid container spacing={2}>
              {faqs.map((faq, index) => (
                <Grid item md={6}>
                  <Accordion
                    key={index}
                    sx={{
                      background: "transparent",
                      border: "transparent",
                      borderRadius: "16px !important",
                      backgroundColor: "#F9F9F9",
                      boxShadow: "none",
                      "&.Mui-expanded": {
                        marginBottom: 0,
                        marginTop: 0,
                      },
                      "& .MuiPaper-root": {
                        marginBottom: 0,
                        marginTop: 0,
                      },
                    }}
                    expanded={expanded === `panel${index}`}
                    onChange={handleAccordionChange(`panel${index}`)}
                  >
                    <AccordionSummary
                      expandIcon={
                        i18n.language === "en" ? (
                          <ArrowRight
                            style={{
                              transform:
                                expanded === `panel${index}`
                                  ? "rotate(-90deg)"
                                  : "rotate(0deg)",
                              transition: "transform 0.3s",
                              fontSize: "24px",
                            }}
                          />
                        ) : (
                          <ArrowLeft
                            style={{
                              transform:
                                expanded === `panel${index}`
                                  ? "rotate(-270deg)"
                                  : "rotate(0deg)",
                              transition: "transform 0.3s",
                              fontSize: "24px",
                            }}
                          />
                        )
                      }
                      sx={{
                        p: 3,
                        borderRadius: "16px",
                        marginBottom: 0,
                        "& .MuiAccordionSummary-content": {
                          my: "0 !important",
                        },
                        "&.Mui-expanded": { my: 0, minHeight: "auto" },
                        minHeight: "auto",
                      }}
                      aria-controls={`panel${index}-content`}
                      id={`panel${index}-header`}
                    >
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontSize: 16,
                          fontWeight: 600,
                          letterSpacing: "0.17px",
                        }}
                      >
                        {t(faq.question)}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ pt: 0, px: 3, pb: 3 }}>
                      <Typography>{t(faq.answer)}</Typography>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>
      </div>
    </>
  );
};

export default CityToCityTransfer;
